import type { Locale } from './index';

/**
 * The cookie that records a language the visitor picked themselves.
 *
 * Deliberately separate from NEXT_LOCALE. NEXT_LOCALE is written by the
 * middleware on anything touching a locale-prefixed URL, so its presence only
 * ever meant "has been here", never "has decided". The Gulf geo-redirect is
 * gated on this one instead, which is why a Saudi visitor who landed on the
 * English site last week still gets shown the Arabic one.
 *
 * A year, not 30 days: a choice is a choice. What used to expire was the
 * redirect suppression, which is the opposite of what should age out.
 */
export const LOCALE_CHOICE_COOKIE = 'LOCALE_CHOICE';
export const LOCALE_CHOICE_MAX_AGE = 60 * 60 * 24 * 365;

/**
 * Records the pick from the browser, on click, before the navigation lands.
 *
 * Client-side rather than server-side because the switcher's links are plain
 * anchors to the same page in the other language — the request they produce is
 * indistinguishable from someone typing the URL, and only one of those two is
 * a decision.
 */
export function rememberLocaleChoice(locale: Locale): void {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  document.cookie =
    `${LOCALE_CHOICE_COOKIE}=${locale}; path=/; ` +
    `max-age=${LOCALE_CHOICE_MAX_AGE}; samesite=lax${secure}`;
}
